import * as angular from "angular";
import {IController} from "angular";

export class ItemsXAmountCtrl implements IController {
  items: any;
  currency: any;
}

angular
  .module('bringoz.admin.orders')
  .component('itemsXAmount', {
    bindings: {
      items: '<',
      currency: '<'
    },
    template: require('./items-x-amount.html').default,
    controller: ItemsXAmountCtrl

  });
